import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44')
];

export const server_loads = [];

export const dictionary = {
		"/": [9],
		"/(protected)/admin/(content)/aspen-services": [10],
		"/(protected)/admin/(content)/emergency-broadcast": [11],
		"/admin/feedbacks/[id]": [16],
		"/(protected)/admin/(content)/ml-scanner": [12],
		"/ai-workflow": [17],
		"/(protected)/alerts-concept": [13],
		"/alerts": [18,[],[2]],
		"/alerts/[id]": [19,[],[2,3]],
		"/analytics/energy-forecast": [20],
		"/approved-alerts": [21,[],[4]],
		"/approved-alerts/[id]": [22,[],[4,5]],
		"/dashboard": [23],
		"/dashboard/admin": [24],
		"/(protected)/dashboard/admin/data-explorer": [14],
		"/(protected)/dashboard/admin/technician-map": [15],
		"/feedback": [25],
		"/field-tech": [26,[6]],
		"/field-tech/alerts": [27,[6]],
		"/field-tech/profile": [28,[6]],
		"/field-tech/schedule": [29,[6]],
		"/field-tech/session/[id]": [30,[6]],
		"/field-tech/tracking": [31,[6]],
		"/field-tech/work-orders": [32,[6]],
		"/field-tech/work-orders/[id]": [33,[6]],
		"/login": [34],
		"/logs": [35],
		"/ml-predictions": [36],
		"/my-feedback": [37],
		"/my-feedback/[id]": [38],
		"/password-reset": [39],
		"/profile": [40],
		"/reports/daily": [41],
		"/reset-password": [~42],
		"/work-orders": [43,[],[7]],
		"/work-orders/[id]": [44,[],[7,8]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';